import DateRangePicker from "@wojtekmaj/react-daterange-picker/dist/DateRangePicker";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import styled from "styled-components";
import { CreateTooltip, GetDatePreriod } from "../core/Helper";

export default function DateRangeFilterBar(props) {
  const [dateSelected, setDateSelected] = useState(1);
  const [dateRangeValues, changeDateRange] = props.dateRange;

  const setPreriod = (dateStyle, index) => {
    changeDateRange(GetDatePreriod(dateStyle));
    setDateSelected(index);
  };

  const createButton = (index, text, dateStyle) => {
    return CreateTooltip(
      text,
      <FilterButton
        variant={dateSelected === index ? "danger" : "secondary"}
        onClick={() => setPreriod(dateStyle, index)}
      >
        {text}
      </FilterButton>,
      "top"
    );
  };

  return (
    <HBox>
      <HBox>
        <HBox>
          {createButton(1, "Today", "TODAY")}
          {createButton(2, "Last 7 days", "LAST7DAYS")}
          {createButton(3, "This Month", "THISMONTH")}
          {createButton(4, "Last 90 days", "LAST3M")}
          <SpanCaption></SpanCaption>{" "}
          <DateRangePicker
            onChange={changeDateRange}
            value={dateRangeValues}
            format="dd/MM/yyyy"
            locale="th-Th"
            closeCalendar={false}
            clearIcon={null}
          />
        </HBox>
      </HBox>
    </HBox>
  );
}

const HBox = styled.div`
  /* flex: 1; */
  /* padding-top: 5px; */
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
`;

const FilterButton = styled(Button)`
  margin-inline: 1px;
  /* padding-inline: 2px; */
  /* padding-block: 0px; */
`;

const SpanCaption = styled.div`
  padding-inline: 5px;
  padding-block: 10px;
  color: #0334d3;
`;
